import type { Address } from "viem"
import type { Config } from "wagmi"

import type { EmitEvent } from "@/domains/core"
import { EventEmitter } from "@/domains/library"
import { claimLpFees } from "@/domains/on-chain"

export type ClaimLpFeesInteractionParams = {
  account: Address
  chainId: number
  config: Config
  pairAddress: Address

  pairDisplayName: string
  emitter: EventEmitter<EmitEvent>
}

export const claimLpFeesInteraction = async ({
  account,
  chainId,
  config,
  pairAddress,

  pairDisplayName,
  emitter,
}: ClaimLpFeesInteractionParams) => {
  const result = await claimLpFees({
    account,
    chainId,
    config,
    pairAddress,
  })

  if (result.success === true) {
    emitter.emit("claimed-lp-fees", {
      title: "Claim LP fees",
      description: `Claimed fees for ${pairDisplayName}`,
      variant: "success",
    })
    return result
  }

  // I prefer to be explicit about this, but eslint doesn't like it
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  if (result.success === false) {
    emitter.emit("error-claiming-lp-fees", {
      title: "Claim LP fees",
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      description: result.error,
      variant: "error",
    })
  }
  return result
}
